import { useLayoutEffect } from "react";
import FranchiseStore from "../store/FranchiseStore";
import useDeviceType from "./useDeviceType";

export const useFranchisePagination = (store: FranchiseStore, isCatalogPage: boolean) => {
    const device = useDeviceType();

    useLayoutEffect(() => {
        const limits = {
            catalog: {
                mobile: 12,
                tablet: 12,
                desktop: 16,
                largeDesktop: 20
            },
            home: {
                mobile: 6,
                tablet: 6,
                desktop: 8,
                largeDesktop: 10
            }
        };

        const limitConfig = isCatalogPage ? limits.catalog : limits.home;
        const limit = 
            device.isLargeDesktop ? limitConfig.largeDesktop :
            device.isDesktop ? limitConfig.desktop :
            limitConfig.mobile;

        store.setLimit(limit);
    }, [device, isCatalogPage, store]);

    return Math.ceil(store.totalCount / (store.limit || 1));
};